<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-account-outline">
          <template v-slot:after-heading>
            <div class="text-h6 font-weight-light">
              <span class="text-body-1">Таблица - </span>
              <v-spacer />
              <span class="text-body-2">{{ title }}
                <v-icon
                  v-if="view && form.id!=null && ($store.state.access[8][3] || $store.state.access[8][4] && form.creator && form.creator.id == $store.state.user.id)"
                  @click="$router.push('/table/change?id=' + form.id)"
                >mdi-pencil</v-icon>
                <v-icon
                  v-if="change && form.id!=null"
                  @click="$router.push('/table/view?id=' + form.id)"
                >mdi-eye</v-icon>
              </span>
            </div>
          </template>
          <base-material-tabs color="warning">
            <v-tab
              v-for="(tab, i) in tabs"
              :key="i"
            >
              {{ tab }}
            </v-tab>
            <v-tab-item>
              <form>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.name"
                      color="secondary"
                      label="Название"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.description"
                      color="secondary"
                      label="Описание"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="form.table"
                      color="secondary"
                      label="Служебное название"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    v-if="form.id"
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="form.deleted"
                      color="secondary"
                      label="Удалить"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item>
              <form>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :items="form.fields"
                      :headers="headers"
                      hide-default-header
                      no-data-text="Нет данных для отображения"
                    >
                      <template v-slot:item.name="{item}">
                        <v-text-field
                          v-model="item.name"
                          :disabled="view"
                          label="Имя"
                          @input="fields_input(item)"
                        />
                      </template>
                      <template v-slot:item.key="{item}">
                        <v-text-field
                          v-model="item.key"
                          :disabled="view"
                          label="Ключ"
                          @input="fields_input(item)"
                        />
                      </template>
                      <template v-slot:item.description="{item}">
                        <v-text-field
                          v-model="item.description"
                          :disabled="view"
                          label="Описание"
                          @input="fields_input(item)"
                        />
                      </template>
                      <template v-slot:item.type="{item}">
                        <v-select
                          v-model="item.type"
                          :disabled="view"
                          label="Тип"
                          :items="select.type"
                          @change="fields_input(item)"
                        />
                      </template>
                      <template v-slot:item.show="{item}">
                        <v-checkbox
                          v-model="item.show"
                          :disabled="view"
                          label="Отображать в таблице"
                          @change="fields_input(item)"
                        />
                      </template>
                      <template v-slot:item.action="{item}">
                        <v-icon
                          v-if="!item.new"
                          @click="form.fields = form.fields.filter(a=>a!=item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
          </base-material-tabs>
          <v-row>
            <v-col
              cols="12"
              md="7"
            >
              <v-btn
                v-if="!create"
                :disabled="load"
                min-width="100"
                color="secondary"
                @click="$router.push('/table/list')"
              >
                Назад
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              md="2"
              class="text-right"
            >
              <v-btn
                v-if="!create"
                :disabled="load "
                min-width="100"
                color="primary"
                @click="save(!create)"
              >
                Сохранить
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="text-right"
            >
              <v-btn
                v-if="create"
                min-width="100"
                color="primary"
                :disabled="load"
                @click="create_table"
              >
                Создать
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
      <v-col
        v-if="view"
        cols="12"
        md="4"
      >
        <base-material-tabs color="warning">
          <v-tab v-if="$store.state.access[3][1] || $store.state.access[3][2]">
            События
          </v-tab>
          <v-tab v-if="$store.state.access[5][1] || $store.state.access[5][2]">
            Изменения
          </v-tab>
          <v-tab-item v-if="$store.state.access[3][1] || $store.state.access[3][2]">
            <base-material-card
              class="v-card-profile"
              title="События"
            >
              <v-card-text>
                <v-list-item
                  v-for="(item,index) in events"
                  :key="index"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title v-if="item.type>0 && $store.state.dict.events[item.type]">
                      {{ $store.state.dict.events[item.type].name }} {{ item.start }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span v-if="item.user && item.user_item">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ item.theme }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon
                      large
                      @click="showEvent(item)"
                    >
                      mdi-eye
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  min-width="100"
                  @click="showCreateEvent"
                >
                  Создать
                </v-btn>
              </v-card-actions>
            </base-material-card>
          </v-tab-item>
          <v-tab-item v-if="$store.state.access[5][1] || $store.state.access[5][2]">
            <base-material-card
              class="v-card-profile"
              title="История изменений"
            >
              <v-card-text>
                <v-list-group
                  v-for="(log,index) in logs"
                  :key="index"
                >
                  <v-list-item
                    slot="activator"
                    two-line
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $store.state.dict.log[log.type] }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="log.user">
                        {{ log.user.surname }} {{ log.user.name }} {{ log.user.patronymic }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        {{ log.date_text }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-card>
                    <v-row
                      align="center"
                      justify="center"
                    >
                      <pre class="ma-5"><code class="json">{{ log.diff }}</code></pre>
                    </v-row>
                  </v-card>
                </v-list-group>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="success"
                  width="150"
                  @click="$router.push('/log/list?entity=' + $route.query.id)"
                >
                  Показать все
                </v-btn>
              </v-card-actions>
            </base-material-card>
          </v-tab-item>
        </base-material-tabs>
      </v-col>
      <v-dialog
        v-model="dialog.event.show"
        scrollable
        persistent
      >
        <event-form
          :create="dialog.event.create"
          :view="dialog.event.view"
          :change="dialog.event.change"
          :data="dialog.event.data"
          :show="dialog.event.show"
          @close="dialog.event.show = false, load()"
        />
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import EventForm from './EventForm'
  import $ from 'jquery'
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  export default {
    name: 'DashboardFormsWizard',
    components: { EventForm },
    props: ['create', 'id', 'view', 'change'],
    data: () => ({
      headers: [
        {
          value: 'name',
          text: 'Имя'
        },
        {
          text: 'Ключ',
          value: 'key'
        },
        {
          text: 'Описание',
          value: 'description'
        },
        {
          text: 'Тип',
          value: 'type'
        },
        {
          text: 'Отображать',
          value: 'show'
        },
        {
          value: 'action'
        }
      ],
      dialog: {
        event: {
          show: false,
          item: {},
        },
      },
      events: [

      ],
      select: {
        type: [
          {
            value: 0,
            text: 'Текст'
          },
          {
            value: 1,
            text: 'Дата'
          },
          {
            value: 2,
            text: 'Число'
          }
        ]
      },
      load: false,
      form: {
        name: '',
        description: '',
        table: '',
        fields: []
      },
      dict: {

      },
      logs: [],
      tab: 0,
      tabs: ['Основное', 'Столбцы']
    }),

    computed: {
      title: function () {
        if (this.create) return 'Создание'
        if (this.view) return 'Просмотр'
        if (this.change) return 'Изменение'
      },
    },
    mounted: function () {
      if (this.create) {
        this.form = {
            name: '',
            description: '',
            table: '',
            fields: [{
              new: true
            }]
        }
      } else {
        this.axios.post('/api/table/list', { id: this.$route.query.id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              this.form.date = moment(this.form.date).format('YYYY-MM-DD')
              this.form.fields = this.form.fields || []
              this.form.fields.push({ new: true })
              this.load_events()
              this.load_logs()
            }
          })
      }
    },
    methods: {
      fields_input: function (item) {
        if (item.new) {
          item.new = false
          this.form.fields.push({ new: true })
        }
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          table: this.$route.query.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (const x in result.data.data) {
                result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.$route.query.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          table: this.form.id,
        }
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      save: function () {
        this.load = true
        this.form.fields = this.form.fields.filter(a => !a.new)
        this.axios.post('/api/table/update', this.form)
          .then(result => {
            this.load = false
            if (!result.data.error) {
              this.$store.commit('snackbar', 'Сохранение успешно')
              this.$router.push('/table/list')
            } else {
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            }
          })
          .catch(error => {
            this.load = false
            this.$store.commit('snackbar', 'Ошибка при сохранении')
          })
      },
      create_table () {
        this.load = true
        this.form.fields = this.form.fields.filter(a => !a.new)
        this.axios.post('/api/table/create', this.form)
          .then(result => {
            this.load = false
            if (!result.data.error) {
              this.$store.commit('snackbar', 'Создание успешно')
              this.$router.push('/table/list')
            } else {
              this.$store.commit('snackbar', 'Ошибка при создании')
            }
          })
          .catch(error => {
            this.load = false
            this.$store.commit('snackbar', 'Ошибка при создании')
          })
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
